import React, { useState } from "react";
import { useRoute } from "@react-navigation/native";
import { useDispatch } from "react-redux";
import _ from 'lodash';
import ThemedSafeAreaComponentTop from "components/atoms/ThemedSafeAreaTop";
import ThemedLayout from "components/atoms/ThemedLayout";
import { cartConstants } from "services/redux/cart/constants";
import { SET_CART } from 'services/redux/action-types'
import HelperString from 'utils/helper-string'
import ThemedCalendarStrip from 'components/atoms/ThemedCalendarStrip'
import { RenderBookingCreateItem } from "components/atoms/BookingCreate";
import HelperObject from 'utils/helper-object'
import HelperLocaleSettings from 'utils/helper/HelperLocaleSettings'
import { localeSettingConstants } from 'utils/constants/LocaleSettings'
import Translate from 'utils/translate'
import LocationsSceneBlock from 'scenes/home/book/location/_scene_blocks/locations'
import ObjectRoom from 'utils/objects/room'
import ObjectFloor from 'utils/objects/floor'
import { routeBookingConstants, routeBookingConstantValues } from 'utils/constants/route/RouteBookingConstants'
import BookingFooter from 'scenes/home/book/_components/BookingFooter'
import ObjectBuilding from 'utils/objects/building'
import useRouteParameters from 'utils/hooks/use-route-parameters'
import { dateFormat } from 'utils/helper-date'
import { useBookProvider } from 'scenes/home/book/_providers/BookProvider'

const HomeBookLocationScene = () => {
	
	const route = useRoute();
	const dispatch = useDispatch();
	const _routeParameters = useRouteParameters( route );
	
	const { capacityLoading, timeslotKindsForGroup, bookDate, _timeslotGroup } = useBookProvider()
	
	const [ footerHeight, setFooterHeight ] = useState( 0 );
	
	const onModeChange = ( mode ) => {
		HelperLocaleSettings.set( localeSettingConstants.CALENDAR_VIEW_MODE_BOOKINGS, mode );
	}
	
	const setDate = ( date ) => {
		dispatch({
			type: SET_CART,
			key: cartConstants.BOOK_DATE,
			payload: date
		});
	}
	
	if( _.isEmpty( timeslotKindsForGroup ) ) {
		return null;
	}
	
	let title = Translate.field( _timeslotGroup, 'title' );
	let subtitle = [];
	
	const depthLevel = _.get( _routeParameters, routeBookingConstants.DEPTH_LEVEL, routeBookingConstantValues[ routeBookingConstants.DEPTH_LEVEL ].BUILDING  );
	const buildingGuid =  _.get( _routeParameters, routeBookingConstants.BUILDING, null );
	const floorGuid = _.get( _routeParameters, routeBookingConstants.FLOOR, null );
	
	let building = undefined;
	let floor = undefined;
	let locations = [];
	
	if( !_.isEmpty( _timeslotGroup.buildingTree ) ){
		building = buildingGuid !== null ? _timeslotGroup.buildingTree[ buildingGuid ] : undefined;
		floor = building !== undefined && floorGuid !== null ? building.floors[ floorGuid ] : undefined;
		
		switch( true ) {
			case ( building !== undefined && floor !== undefined ):
				locations = ObjectRoom.filterAndOrder( ObjectRoom.get( floor?.rooms ) );
				break;

			case ( building !== undefined ):
				locations = ObjectFloor.filterAndOrder( ObjectFloor.get( building?.floors ) );
				break;

			default:
				locations = ObjectBuilding.filterAndOrder( HelperObject.groupByGuid( _timeslotGroup.buildingTree ) );
				break;
		}
	}
	
	let calendarContent = null;
	if( _.get( capacityLoading, bookDate.format( dateFormat.DATE ), false ) === false && !_.isEmpty( _timeslotGroup.buildingTree ) ) {
		if( !_.isEmpty( building ) ){
			subtitle.push( Translate.field( building, 'title' ) );
		}
		
		if( !_.isEmpty( floor ) ){
			subtitle.push( Translate.field( floor, 'title' ) );
		}
		
		calendarContent = (
			<LocationsSceneBlock
				depthLevel={ depthLevel }
				locations={ locations }
				building={ building }
				floor={ floor }
				timeslotKindsForGroup={ timeslotKindsForGroup }
			/>
		)
	}
	
	return (
		<ThemedSafeAreaComponentTop
			top={false}>

			<ThemedLayout
				contentWidth="narrow"
				title={ title }
				subtitle={ subtitle.join( ", " ) }
				showBackButton={ true }
				footerBar={ footerHeight > 0 }
				style={ {
					paddingBottom: footerHeight + 10
				} }>
				
				<ThemedCalendarStrip
					key={ HelperString.hash( 'themed-calendar-strip' ) }
					selectDate={ setDate.bind( this ) }
					enableMinDate={ false }
					date={ bookDate }
					renderItem={ RenderBookingCreateItem }
					onModeChange={ onModeChange.bind( this ) }
					disableTimeslots={ true }>
					
					{ calendarContent }
				</ThemedCalendarStrip>
			</ThemedLayout>
			
			<BookingFooter
				onHeight={ setFooterHeight }
				showSubmitButton={ false }
			/>
		</ThemedSafeAreaComponentTop>
	)
}

export default HomeBookLocationScene
